export default {
    information: {
        content1Content:
            'Document template in both Japanese and English is available. Our full bilingual support team is happy to support.',
        content1Title: 'Bilingual Support',
        content2Content:
            'Send your invoices via our Secure Send. For Japan, even through the post could be handled by us.',
        content2Title: 'Send Documents with One Click',
        content3Content:
            'Our bankbook sync and machine learning algorithm will give you the simplest way to keep track of your payment receivables.',
        content3Title: 'One Place Payment Management',
        title: 'Upgrade Your Invoicing Operations',
    },
    pageForm: {
        letsGetStarted: "Let's get started",
        registrationCode:
            '<0>Do you have a registration code?</0> Enter it now',
        subtitle:
            '30-day trial of our features. Your free trial will not automatically become a paid subscription.',
        title: 'Create Your Free Account',
    },
};
